export const countryNamesPtBR = {
  af: "Afeganistão",
  al: "Albânia",
  dz: "Argélia",
  ad: "Andorra",
  ao: "Angola",
  ag: "Antígua e Barbuda",
  ar: "Argentina",
  am: "Armênia",
  aw: "Aruba",
  au: "Austrália",
  at: "Áustria",
  az: "Azerbaijão",
  bs: "Bahamas",
  bh: "Bahrein",
  bd: "Bangladesh",
  bb: "Barbados",
  by: "Bielorrússia",
  be: "Bélgica",
  bz: "Belize",
  bj: "Benin",
  bt: "Butão",
  bo: "Bolívia",
  ba: "Bósnia e Herzegovina",
  bw: "Botsuana",
  br: "Brasil",
  io: "Território Britânico do Oceano Índico",
  bn: "Brunei",
  bg: "Bulgária",
  bf: "Burkina Faso",
  bi: "Burundi",
  kh: "Camboja",
  cm: "Camarões",
  ca: "Canadá",
  cv: "Cabo Verde",
  bq: "Caribe Neerlandês",
  ky: "Ilhas Cayman",
  cf: "República Centro-Africana",
  td: "Chade",
  cl: "Chile",
  cn: "China",
  co: "Colômbia",
  km: "Comores",
  cd: "Congo",
  cg: "Congo",
  cr: "Costa Rica",
  ci: "Costa do Marfim",
  hr: "Croácia",
  cu: "Cuba",
  cw: "Curaçao",
  cy: "Chipre",
  cz: "República Tcheca",
  dk: "Dinamarca",
  dj: "Djibuti",
  dm: "Dominica",
  do: "República Dominicana",
  ec: "Equador",
  eg: "Egito",
  sv: "El Salvador",
  gq: "Guiné Equatorial",
  er: "Eritreia",
  ee: "Estônia",
  et: "Etiópia",
  fo: "Ilhas Faroe",
  fj: "Fiji",
  fi: "Finlândia",
  fr: "França",
  gf: "Guiana Francesa",
  pf: "Polinésia Francesa",
  ga: "Gabão",
  gm: "Gâmbia",
  ge: "Geórgia",
  de: "Alemanha",
  gh: "Gana",
  gr: "Grécia",
  gl: "Groenlândia",
  gd: "Granada",
  gp: "Guadalupe",
  gu: "Guam",
  gt: "Guatemala",
  gn: "Guiné",
  gw: "Guiné-Bissau",
  gy: "Guiana",
  ht: "Haiti",
  hn: "Honduras",
  hk: "Hong Kong",
  hu: "Hungria",
  is: "Islândia",
  in: "Índia",
  id: "Indonésia",
  ir: "Irã",
  iq: "Iraque",
  ie: "Irlanda",
  il: "Israel",
  it: "Itália",
  jm: "Jamaica",
  jp: "Japão",
  jo: "Jordânia",
  kz: "Cazaquistão",
  ke: "Quênia",
  ki: "Kiribati",
  xk: "Kosovo",
  kw: "Kuwait",
  kg: "Quirguistão",
  la: "Laos",
  lv: "Letônia",
  lb: "Líbano",
  ls: "Lesoto",
  lr: "Libéria",
  ly: "Líbia",
  li: "Liechtenstein",
  lt: "Lituânia",
  lu: "Luxemburgo",
  mo: "Macau",
  mk: "Macedônia do Norte",
  mg: "Madagascar",
  mw: "Malawi",
  my: "Malásia",
  mv: "Maldivas",
  ml: "Mali",
  mt: "Malta",
  mh: "Ilhas Marshall",
  mq: "Martinica",
  mr: "Mauritânia",
  mu: "Maurício",
  yt: "Mayotte",
  mx: "México",
  fm: "Micronésia",
  md: "Moldávia",
  mc: "Mônaco",
  mn: "Mongólia",
  me: "Montenegro",
  ma: "Marrocos",
  mz: "Moçambique",
  mm: "Myanmar",
  na: "Namíbia",
  nr: "Nauru",
  np: "Nepal",
  nl: "Holanda",
  nc: "Nova Caledônia",
  nz: "Nova Zelândia",
  ni: "Nicarágua",
  ne: "Níger",
  ng: "Nigéria",
  kp: "Coreia do Norte",
  no: "Noruega",
  om: "Omã",
  pk: "Paquistão",
  pw: "Palau",
  ps: "Palestina",
  pa: "Panamá",
  pg: "Papua-Nova Guiné",
  py: "Paraguai",
  pe: "Peru",
  ph: "Filipinas",
  pl: "Polônia",
  pm: "São Pedro e Miquelão",
  pt: "Portugal",
  pr: "Porto Rico",
  qa: "Catar",
  re: "Reunião",
  ro: "Romênia",
  ru: "Rússia",
  rw: "Ruanda",
  kn: "São Cristóvão e Névis",
  lc: "Santa Lúcia",
  vc: "São Vicente e Granadinas",
  ws: "Samoa",
  sm: "San Marino",
  st: "São Tomé e Príncipe",
  sa: "Arábia Saudita",
  sn: "Senegal",
  rs: "Sérvia",
  sc: "Seychelles",
  sl: "Serra Leoa",
  sg: "Singapura",
  sk: "Eslováquia",
  si: "Eslovênia",
  sb: "Ilhas Salomão",
  so: "Somália",
  za: "África do Sul",
  kr: "Coreia do Sul",
  ss: "Sudão do Sul",
  es: "Espanha",
  lk: "Sri Lanka",
  sd: "Sudão",
  sr: "Suriname",
  sz: "Essuatíni",
  se: "Suécia",
  ch: "Suíça",
  sy: "Síria",
  tw: "Taiwan",
  tj: "Tajiquistão",
  tz: "Tanzânia",
  th: "Tailândia",
  tl: "Timor-Leste",
  tg: "Togo",
  to: "Tonga",
  tt: "Trinidad e Tobago",
  tn: "Tunísia",
  tr: "Turquia",
  tm: "Turcomenistão",
  tv: "Tuvalu",
  ug: "Uganda",
  ua: "Ucrânia",
  ae: "Emirados Árabes Unidos",
  gb: "Reino Unido",
  us: "Estados Unidos",
  uy: "Uruguai",
  uz: "Uzbequistão",
  vu: "Vanuatu",
  va: "Vaticano",
  ve: "Venezuela",
  vn: "Vietnã",
  wf: "Wallis e Futuna",
  ye: "Iêmen",
  zm: "Zâmbia",
  zw: "Zimbábue",
};

export const getCountryName = (iso2) => {
  return countryNamesPtBR[iso2?.toLowerCase()] || iso2?.toUpperCase() || "";
};
